import React, {FC, ReactElement} from 'react';
import './MultipleButtons.scss';
import styled from 'styled-components';
import Element from '../Element';

export type multipleButtonsProps = {
    buttonsData:any,
    index:number,
    editorPlugins: any|null,
    path: {
        slideIndex: number,
        comboIndex: number,
        setIndex: number,
        groupIndex: number,
        elementIndex: number,
        subElementIndex: number|null,
    } | null,
}

type multipleButtonsWrapperProps = {

}

export const MultipleButtonsWrapper = styled.div<multipleButtonsWrapperProps>`

`;


const MultipleButtons: FC<multipleButtonsProps> = ({...props}): ReactElement => {

    let isEditor = props.editorPlugins;

    if(isEditor) {
        const MultiEditor = require('./MultipleButtonsEditor').default
        return <MultiEditor {...props}/>;
    }
    else {
        return (
            <MultipleButtonsWrapper>
                <div className={'buttonsList'}>
                    {
                        props.buttonsData.map((element: any, index: number) => {
                            return (<div key={index} className={'listItem'}>
                                    <Element key={index} elementData={element} index={null} path={null} editorPlugins={null}/>
                                </div>
                            )
                        })
                    }
                </div>
            </MultipleButtonsWrapper>
        )
    }

};

let settings:any;
let SettingsData;
const environmentLink:any = window.getEnvironmentLink();
try {
    SettingsData = require('../../../settings-data').default;
    // do stuff
} catch (ex) {
    SettingsData = null;
}
if(SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [];
}

const options:any = []

export default {
    MultipleButtons,
    settings,
    options
};

